export const SUB_LOCATIONS = "Sub_locatons";
export const INPUT_CHANGEVALUE = "Sub_locatons_input_ChangeValue";
export const SELECT_CHANGEVALUE = "Sub_locatons_Select_ChangeValue";

export const SUB_LOCATIONS_ADD = "Sub_Location_add";
export const SUB_LOCATIONS_ROW_DATA = "Sub_location_Row_data";

export const SUB_LOCATIONS_DELETE = "Sub_location_deleted";

export const SUB_LOCATIONS_SETROWDATA = "Sub_location_set_rowdata";
export const MODEL_OPEN = "Sub_location_model_open";
export const MODEL_CLOSE = "Sub_location_model_close";

export const SUB_LOCATIONS_LIST_SUCCESSFUL = "Sub_locaton_list_successfull";
export const SUB_LOCATIONS_ADD_SUCCESSFUL = "Sub_locaton_add_successfull";
export const SUB_LOCATIONS_ROW_DATA_SUCCESSFUL =
  "Sub_location_row_data_successfull";
  
export const SET_PARAMS = "Sub_locaton_set_params";

export const API_ERROR = "api_failed";
